import { GenericMessage } from "components/feedback/Message";
import { useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useComparateurNotifications } from "shared/signalR/hooks/useComparateurNotifications";
import { ComparateurPricingUpdateDto } from "shared/signalR/types";
import { BorrowerPricingFunnels } from "./components/pricing-funnels/BorrowerPricingFunnels";
import { BorrowerPricingHeader } from "./components/pricing-header/BorrowerPricingHeader";
import { BorrowerPricingSideMenu } from "./components/pricing-side-menu/BorrowerPricingSideMenu";
import ShoppingCartPanel from "./components/shopping-cart/SideShoppingCart";
import { useMainBorrowerPricingActions, useMainBorrowerPricingState } from "./contexts/main-borrower-pricing/MainBorrowerPricingContext";

export const BorrowerPricingProcess: React.FC = () => {
  const { initBorrowerPricingProcessAsync, updateFunnelPricing } = useMainBorrowerPricingActions();
  const { globalWarningMessages, borrowerId: stateBorrowerId } = useMainBorrowerPricingState()
  const { borrowerProjectId, borrowerId } = useParams<{
    borrowerProjectId: string;
    borrowerId?: string;
  }>();

  // Callback pour traiter les notifications SignalR de pricing
  const handlePricingUpdate = useCallback((update: ComparateurPricingUpdateDto) => {
    updateFunnelPricing(update);
  }, [updateFunnelPricing]);

  // Connexion SignalR pour recevoir les mises à jour de pricing en temps réel
  const { memoizedConnect, memoizedDisconnect } = useComparateurNotifications(
    stateBorrowerId,
    handlePricingUpdate
  );

  useEffect(() => {
    if (borrowerProjectId) {
      initBorrowerPricingProcessAsync({
        borrowerProjectId,
        emprunteurId: borrowerId
      })
    }
  }, [borrowerProjectId, borrowerId, initBorrowerPricingProcessAsync])

  // Connecter/déconnecter SignalR quand le borrowerId change
  useEffect(() => {
    if (stateBorrowerId) {
      memoizedConnect();
    }
    return () => {
      memoizedDisconnect();
    };
  }, [stateBorrowerId, memoizedConnect, memoizedDisconnect]);

  return (
    <div className="flex gap-6 flex-col max-w-screen-2xl p-4 md:p-8 mt-8 mx-auto">
      <div>
        <BorrowerPricingHeader />
        {globalWarningMessages.length > 0 &&
          globalWarningMessages.map((message, index) => <GenericMessage
            key={index}
            className="mt-4"
            size="sm"
            message={message}
            dismissible={false}
            type="warning"
          />)
        }
      </div>
      <div className="flex flex-col xl:flex-row gap-6">
        <BorrowerPricingSideMenu />
        <BorrowerPricingFunnels />
        <ShoppingCartPanel />
      </div>
    </div>
  );
};
